export default "__VITE_ASSET__ELkJsLRO__"